/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentDetailByIdQueryResponse, WebAppGetFragmentDetailByIdPathParams, WebAppGetFragmentDetailById404 } from "../models/WebAppGetFragmentDetailById";

export function getWebAppGetFragmentDetailByIdUrl(id: WebAppGetFragmentDetailByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/web-app/v1/fragments/${id}` as const }
  return res
}

/**
 * @summary Get one fragment by id
 * {@link /web-app/v1/fragments/:id}
 */
export async function webAppGetFragmentDetailById(id: WebAppGetFragmentDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetFragmentDetailByIdQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailById404>, unknown>({ method : "GET", url : getWebAppGetFragmentDetailByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}